module.exports = __webpack_public_path__ + "static/media/react.6b96a3ac.svg";